import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-date",
  "use": "icon-date-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-date\">\n  <path fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.909,4H5.091C4.491,4,4,4.491,4,5.091v9.818C4,15.509,4.491,16,5.091,16h9.818 c0.6,0,1.091-0.491,1.091-1.091V5.091C16,4.491,15.509,4,14.909,4z M5.636,14.363V7.818h8.727v6.545H5.636z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol